import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Pharmacy setup wizard: main SuperAdmin only (created by God, isMainSuperAdmin true).
 * Sub SuperAdmins have isMainSuperAdmin false; God uses role God, not SuperAdmin.
 * Legacy admins may omit the flag — treat as main so they retain access.
 */
export function useCanAccessPharmacySetup(): boolean {
  const { user } = useAuth();
  return useMemo(() => {
    if (!user || user.role !== 'SuperAdmin') return false;
    return user.isMainSuperAdmin !== false;
  }, [user]);
}
